import type * as BackendContract from '#backend/contract';
import { Sort } from '@angular/material/sort';

/**
 * adaptador de objeto sort (data table frontend) para orderby (consulta backend).
 * converte {active: 'pai.filho.neto', direction: 'asc'} para
 * {pai: {filho: {neto:'asc'}}}
 */
export function createNestedOrder(
  sortObject: Sort,
): BackendContract.FindOptionsOrder<unknown> {
  const keys = sortObject.active.split('.'); // ex: ["status", "code"]

  const nestedObject: any = {};
  keys.reduce((acc, key, index) => {
    if (index === keys.length - 1) {
      acc[key] = sortObject.direction;
    } else {
      acc[key] = acc[key] || {};
    }
    return acc[key];
  }, nestedObject);

  return nestedObject;
}
